export type ExerciseMeta = {
  movieName: string;
  movieCopyright: string;
};
